"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionnaireItemEnabled = void 0;
/* ========================================================================
    Module: Questionnaire item enabled
 ========================================================================== */
/**
 * アンケートの回答のチェックによってサブ項目を有効／無効化する
 *
 * @returns {void}
 */
const questionnaireItemEnabled = () => {
    const answerItemElements = document.querySelectorAll(".js-answer-item");
    if (answerItemElements.length === 0) {
        return;
    }
    answerItemElements.forEach((element) => {
        const answerMainElement = element.querySelector(".js-answer-main");
        const answerSubItemElements = element.querySelectorAll(".js-answer-sub-item");
        if (!answerMainElement) {
            return;
        }
        // メイン回答のイベントリスナーを設定する
        answerMainElement.addEventListener("change", (e) => {
            if (!(e.currentTarget instanceof HTMLInputElement) ||
                answerSubItemElements.length === 0) {
                return;
            }
            const mainElement = e.currentTarget;
            answerSubItemElements.forEach((element) => {
                const subFormControlElements = element.querySelectorAll("input, select, textarea");
                subFormControlElements.forEach((element) => {
                    if (mainElement.checked) {
                        element.disabled = false;
                    }
                    else {
                        element.disabled = true;
                    }
                });
            });
            // サブの回答ラジオボタンのイベントを発火する
            answerSubItemElements.forEach((element) => {
                const answerSubElements = element.querySelectorAll(".js-answer-sub");
                answerSubElements.forEach((element) => {
                    element.dispatchEvent(new Event("change"));
                });
            });
        });
        // サブ回答のイベントリスナーを設定する
        answerSubItemElements.forEach((element) => {
            const answerSubElements = element.querySelectorAll(".js-answer-sub");
            answerSubElements.forEach((element) => {
                element.addEventListener("change", (e) => {
                    changeAnswerSub(e, answerSubItemElements);
                });
                element.dispatchEvent(new Event("change"));
            });
        });
        answerMainElement.dispatchEvent(new Event("change"));
    });
};
exports.questionnaireItemEnabled = questionnaireItemEnabled;
/**
 * サブ回答のイベントハンドラー
 *
 * @param {Event} e
 * @param {NodeListOf<HTMLInputElement>} answerSubItemElements
 * @returns {void}
 */
const changeAnswerSub = (e, answerSubItemElements) => {
    answerSubItemElements.forEach((element) => {
        const answerSubElement = element.querySelector(".js-answer-sub");
        if (!answerSubElement || answerSubElement.type !== "radio") {
            return;
        }
        const nextElement = answerSubElement.parentElement?.nextElementSibling;
        if (nextElement instanceof HTMLInputElement) {
            // 親のラジオボタンが disabled の場合は
            // 選択状態に関係なく強制的に disabled にする
            if (answerSubElement.disabled === true) {
                nextElement.disabled = true;
            }
            else {
                if (answerSubElement.checked) {
                    nextElement.disabled = false;
                }
                else {
                    nextElement.disabled = true;
                }
            }
        }
    });
};
